import React, {Component} from "react";

import Table from "../../components/Table/Table";
import {Col} from "react-bootstrap";
import {request} from "../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import Alert from "react-s-alert";
import MiniButton from "../../components/MiniButton";
import SweetAlert from "react-bootstrap-sweetalert";

class PayTrPrefixList extends Component{
    constructor(props) {
        super(props);
        this.state = {
            manual: false,
            content: [],
            changeList: [],
            deletedList: [],
            total: 0,
            loading: false,
            searching: false,
            searchQuery: undefined,
            page: 0,
            size: 10,
            addModal: false,
            alert: null,
        };
        this.fetchData = this.fetchData.bind(this)
        this.onChange = this.onChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.savePayTrPrefix = this.savePayTrPrefix.bind(this);
        this.addPayTrPrefix = this.addPayTrPrefix.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
    }

    fetchData(accessor, direction, page, size){
        let self = this;
        let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '&sort=updatedAt,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;

        let params = {
            url: '/payTrOrder/fetchPayTrPrefix/?page=' + page + '&size=' + size + searchQuery + sortStr,
            method: "get",
        };

        self.setState({loading: true, searching: true, manual: self.manual === true ? false : self.manual});
        request(params)
            .then(function (response) {
                self.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    content: response.data.content,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    onChange(e,index){
        let name = e.target.name;
        let value =e.target.value;
        let content = deepCopyObject(this.state.content);
        let changeList = deepCopyObject(this.state.changeList)

        content[index][name] = value;
        let add = true;
        changeList.map(change => {
            if (change.recordId === content[index].recordId){
                change[name] = value
                add = false;
            }
        });
        if (add)
            changeList.push(content[index]);

        this.setState({content, changeList});
    }

    handleSearch(searchQuery) {
        this.setState({
            searchQuery,
            searching: true
        }, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
    }

    savePayTrPrefix() {
        let self = this;
        self.setState({loading: true})
        let data = deepCopyObject(self.state.changeList);

        let params = {
            url: '/payTrOrder/savePrefix',
            method: "post",
            data: data
        };

        request(params)
            .then(function (response) {
                Alert.success("Prefixleriniz başarı ile kaydedildi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                }, () => self.fetchData(this.state.accessor, this.state.direction, 0, this.state.size));
                self.setState({loading: false, changeList: []})
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });

    }

    addPayTrPrefix() {
        let self = this;
        let content = deepCopyObject(self.state.content);
        content.push({
            host: "",
            customerPrefix: "",
            invoicePrefix: "",
            eainvoicePrefix: "",
        });
        self.setState({content});
    }

    deleteRow(item,index) {
        let self = this;
        let content = deepCopyObject(self.state.content);
        let changeList = deepCopyObject(self.state.changeList);

        content.splice(index,1);
        if(item.recordId !== null && item.recordId !== undefined){
            item.deletedAt = new Date();
            changeList.push(item);
        }else{
            changeList.splice(changeList.findIndex(index => index === item),1);
        }
        self.setState({changeList,content, alert: null});
    }

    render() {
        const columns = [
            {
                Header: "#",
                accessor: "recordId",
                sortable:false,
                Cell: (row,index)=>(<div style={{margin:0}}>{index+1}</div>)
            },
            {
                Header: <div style={{textAlign: 'center'}}>Host</div>,
                accessor: "host",
                sortable: false,
                Cell:(row,index) => (
                    <div>
                        <input
                            className="form-control"
                            type="text"
                            id="host"
                            value={row.host}
                            onChange={(e) => this.onChange(e,index)}
                            name="host"/>
                    </div>
                )
            },
            {
                Header: <div style={{textAlign: 'center'}}>Müşteri Prefixi</div>,
                accessor: "customerPrefix",
                sortable: false,
                Cell:(row,index) => (
                    <div>
                        <input
                            className="form-control"
                            type="text"
                            id="customerPrefix"
                            value={row.customerPrefix}
                            onChange={(e) => this.onChange(e,index)}
                            name="customerPrefix"/>
                    </div>
                )
            },
            {
                Header: <div style={{textAlign: 'center'}}>E-Fatura Prefixi</div>,
                accessor: "invoicePrefix",
                sortable: false,
                Cell:(row,index) => (
                    <div>
                        <input
                            className="form-control"
                            type="text"
                            id="invoicePrefix"
                            value={row.invoicePrefix}
                            onChange={(e) => this.onChange(e,index)}
                            name="invoicePrefix"/>
                    </div>
                )
            },
            {
                Header: <div style={{textAlign: 'center'}}>E-Arşiv Fatura Prefixi</div>,
                accessor: "eainvoicePrefix",
                sortable: false,
                Cell:(row,index) => (
                    <div>
                        <input
                            className="form-control"
                            type="text"
                            id="eainvoicePrefix"
                            value={row.eainvoicePrefix}
                            onChange={(e) => this.onChange(e,index)}
                            name="eainvoicePrefix"/>
                    </div>
                )
            },
            {
                Header: "İşlemler",
                accessor: "",
                Cell: (item, index) => (
                    <div>
                        {item.recordId !== undefined
                            ?
                            <MiniButton title="Sil"
                                        faIcon="fa-trash"
                                        color="danger"
                                        style={{margin: "0", background: '#fd7a7a'}}
                                        onClick={() => this.setState({
                                            alert: (
                                                <SweetAlert showCancel warning
                                                            disabled={this.state.deleteBtnDisabled}
                                                            confirmBtnText="Evet"
                                                            cancelBtnText="Hayır"
                                                            confirmBtnBsStyle="danger"
                                                            cancelBtnBsStyle="default"
                                                            title="Emin misiniz?"
                                                            onConfirm={() => {
                                                                this.deleteRow(item, index)
                                                            }}
                                                            onCancel={() => this.setState({alert: null})}
                                                >
                                                    Prefix tablodan silinecek.
                                                </SweetAlert>
                                            )
                                        })}/>
                            :
                            <MiniButton title="Sil"
                                        faIcon="fa-trash"
                                        color="danger"
                                        style={{margin: "0", background: '#fd7a7a'}}
                                        onClick={() => this.deleteRow(item, index)}/>
                        }
                    </div>
                )
            }
        ];

        let fields = [
            {
                label: "Host",
                accessor: "host",
                type: "text",
                operator: "="
            },
            {
                label: "Müşteri Prefix",
                accessor: "customerPrefix",
                type: "text",
                operator: "="
            },
            {
                label: "E-Fatura Prefixi",
                accessor: "invoicePrefix",
                type: "text",
                operator: "="
            },
            {
                label: "E-Arşiv Fatura Prefixi",
                accessor: "eainvoicePrefix",
                type: "text",
                operator: "="
            },
        ];

        return (
            <Col sm="12">

                <div>{this.state.alert}</div>

                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="" style={{marginTop: '10px', marginBottom: '10px'}} id="PayTrPrefixDetailedContainer">
                                <DetailedSearch fields={fields}
                                                loading={this.state.searching}
                                                onSearch={this.handleSearch} hasContainer="PayTrPrefixDetailedContainer"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-body">
                    <div className=" row">
                        <div className="col-sm-12" style={{float: 'right'}}>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{cursor: 'pointer', background: 'linear-gradient(rgba(154, 193, 218, 0.61), #6e8da2)', padding: '8px 41px 8px 17px', marginBottom: '15px'}}
                                    rel="tooltip" className="TekBtn ekle"
                                    onClick={this.addPayTrPrefix}>
                                Ekle
                            </button>
                        </div>
                    </div>
                    <div className=" row">
                        <div className="col-sm-12">
                            <Table columns={columns}
                                   loading={this.state.loading}
                                   loadingText="Kayıtlar getiriliyor..."
                                   content={this.state.content}
                                   total={this.state.total}
                                   page={this.state.page}
                                   manual={this.state.manual}
                                   size={this.state.size}
                                   options={["5", "10", "20", "50", "100"]}
                                   fetchData={this.fetchData}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-sm-4">
                    <button type="button" data-toggle="tooltip" data-placement="bottom"
                            style={{cursor: 'pointer', background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding: '8px 41px 8px 17px', marginBottom: '15px'}}
                            rel="tooltip" className="TekBtn kaydet"
                            onClick={this.savePayTrPrefix}>
                        Kaydet
                    </button>
                </div>

            </Col>
        )
    }
}
export default PayTrPrefixList;